/**
 *
 * Asynchronously loads the SourcingPurchaseNew component
 *
 */

import { Loader } from '@fountain/fountain-ui-components';

import loadable from 'utils/loadable';

export default loadable(() => import('./index'), {
  LoadingComponent: Loader,
});
